import axios from 'axios';
import { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import {
    IScheduleAvailabilitiesResponse,
    IScheduleContainerVariableValue,
    IScheduleSlotAvailableMembersResponse,
    IVariableResponse
} from '~/types/server.types';
import { TFlowStatus } from '~/types/model.types';
import { TFullTimezone } from '~/utils/timezone.utils';

export interface IVariableStatusResponse {
    variable: IVariableResponse<IScheduleContainerVariableValue>;
    new_status: TFlowStatus;
}

export class CXScheduleService {
    rootStore: CXRootStore;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    async getAvailabilities(params: {
        startDate: string;
        endDate: string;
        timezone: TFullTimezone;
        sessionTypeId: string;
        placementId: string;
        workspaceId: string;
        source: string;
    }) {
        // TBD Fill with correct member id / change source when decided (SE / Rails)
        const response = await axios.get<IScheduleAvailabilitiesResponse>(
            '/api/availability',
            {
                baseURL:
                    this.rootStore.configStore.config.scheduling_engine_url,
                params
            }
        );

        return response.data;
    }

    async getSlotAvailableMembers(params: {
        selectedDate: string;
        timezone: TFullTimezone;
        sessionTypeId: string;
        placementId: string;
        workspaceId?: string;
    }) {
        const response = await axios.get<IScheduleSlotAvailableMembersResponse>(
            '/api/availability/members',
            {
                baseURL:
                    this.rootStore.configStore.config.scheduling_engine_url,
                params
            }
        );

        return response.data;
    }

    async selectSlot({
        flowId,
        revisionId,
        pageId,
        variableId,
        selectedDate,
        timezone,
        userIds
    }: {
        flowId: string;
        revisionId: string;
        pageId: string;
        variableId: string;
        selectedDate: string;
        timezone: TFullTimezone;
        userIds: string[];
    }) {
        const { apiService } = this.rootStore;

        return apiService.apiRequest<IVariableStatusResponse>({
            method: 'put',
            url: `/api/v2/flow/${flowId}/select_slot/${pageId}`,
            data: {
                revision_id: revisionId,
                variable_id: variableId,
                data: {
                    selected_date: selectedDate,
                    client_timezone: timezone,
                    user_ids: userIds
                }
            }
        });
    }

    async cancelSession({
        flowId,
        revisionId,
        pageId,
        variableId,
        message
    }: {
        flowId: string;
        revisionId: string;
        pageId: string;
        variableId: string;
        message: string;
    }) {
        const { apiService } = this.rootStore;

        return apiService.apiRequest<IVariableStatusResponse>({
            method: 'put',
            url: `/api/v2/flow/${flowId}/cancel_session/${pageId}`,
            data: {
                revision_id: revisionId,
                data: {
                    variable_id: variableId
                },
                message
            }
        });
    }
}
